// ** React Imports
import { createContext, useEffect, useState } from 'react'

// ** Next Import
import { useNavigate } from 'react-router-dom' // Replacing Next.js router

// ** Axios
import axios from 'axios'

// ** Config
// import { useSmartClaim } from 'src/hooks/smartClaim'
import { userData } from '../hooks/userData'
// import { useAuth } from 'src/hooks/useAuth'
// import { gridColumnGroupsLookupSelector } from '@mui/x-data-grid'

// ** Defaults
const defaultProvider = {
  scCompletedCount: null,
  scPendingCount: null,
  scNotSubmited: null,
  selectedUserData: null,
  loading: true,
  setLoading: () => Boolean,
  completedClaim: () => Promise.resolve(),
}
const SmartClaimContext = createContext(defaultProvider)

const SmartClaimProvider = ({ children }) => {
  const navigate = useNavigate() // React Router hook for navigation

  const [selectedUserData, setSelectedUserData] = useState(null)

  const [totalCounts, setTotalCounts] = useState({
    customer_return: 0,
    wrong_rto: 0,
    non_barcode_rto: 0,
    damage: 0,
    missing_qty: 0,
    otp_less: 0,
    payment: 0,
    returns: 0,
    loss: 0,
    smart_claim: 0,
    true_claim: 0
  })

  const [scCustomerReturnCompleteCount, setScCustomerReturnCompleteCount] = useState(0)
  const [scCustomerReturnComplete, setScCustomerReturnComplete] = useState(null)
  const [scCustomerReturnCompleteUserList, setScCustomerReturnCompleteUserList] = useState(null)

  const [scCustomerReturnPendingCount, setScCustomerReturnPendingCount] = useState(0)
  const [scCustomerReturnPending, setScCustomerReturnPending] = useState(null)
  const [scCustomerReturnPendingUserList, setScCustomerReturnPendingUserList] = useState(null)

  const [scCustomerReturnClaimNotSubmitCount, setScCustomerReturnClaimNotSubmitCount] = useState(0)
  const [scCustomerReturnClaimNotSubmit, setScCustomerReturnClaimNotSubmit] = useState(null)
  const [scCustomerReturnClaimNotSubmitUserList, setScCustomerReturnClaimNotSubmitUserList] = useState(null)

  // wrong rto
  const [scRtoReturnCompleteCount, setScRtoReturnCompleteCount] = useState(0)
  const [scRtoReturnComplete, setScRtoReturnComplete] = useState(null)
  const [scRtoReturnCompleteUserList, setScRtoReturnCompleteUserList] = useState(null)

  const [scRtoReturnPendingCount, setScRtoReturnPendingCount] = useState(0)
  const [scRtoReturnPending, setScRtoReturnPending] = useState(null)
  const [scRtoReturnPendingUserList, setScRtoReturnPendingUserList] = useState(null)

  const [scRtoReturnClaimNotSubmitCount, setScRtoReturnClaimNotSubmitCount] = useState(0)
  const [scRtoReturnClaimNotSubmit, setScRtoReturnClaimNotSubmit] = useState(null)
  const [scRtoReturnClaimNotSubmitUserList, setScRtoReturnClaimNotSubmitUserList] = useState(null)

  // non barcode rto
  const [scNonBarcodeRtoCompleteCount, setScNonBarcodeRtoCompleteCount] = useState(0)
  const [scNonBarcodeRtoCompleteCountById, setScNonBarcodeRtoCompleteCountById] = useState(null)
  const [scNonBarcodeRtoCompleteUserList, setScNonBarcodeRtoCompleteUserList] = useState(null)

  const [scNonBarcodeRtoPendingCount, setScNonBarcodeRtoPendingCount] = useState(0)
  const [scNonBarcodeRtoPendingCountById, setScNonBarcodeRtoPendingCountById] = useState(null)
  const [scNonBarcodeRtoPendingUserList, setScNonBarcodeRtoPendingUserList] = useState(null)

  const [scNonBarcodeRtoClaimNotSubmitCount, setScNonBarcodeRtoClaimNotSubmitCount] = useState(0)
  const [scNonBarcodeRtoClaimNotSubmitCountById, setScNonBarcodeRtoClaimNotSubmitCountById] = useState(null)
  const [scNonBarcodeRtoClaimNotSubmitUserList, setScNonBarcodeRtoClaimNotSubmitUserList] = useState(null)

  // damage
  const [scDamageCompleteCount, setScDamageCompleteCount] = useState(0)
  const [scDamageCompleteCountById, setScDamageCompleteCountById] = useState(null)
  const [scDamageCompleteUserList, setScDamageCompleteUserList] = useState(null)

  const [scDamagePendingCount, setScDamagePendingCount] = useState(0)
  const [scDamagePendingCountById, setScDamagePendingCountById] = useState(null)
  const [scDamagePendingUserList, setScDamagePendingUserList] = useState(null)

  const [scDamageClaimNotSubmitCount, setScDamageClaimNotSubmitCount] = useState(0)
  const [scDamageClaimNotSubmitCountById, setScDamageClaimNotSubmitCountById] = useState(null)
  const [scDamageClaimNotSubmitUserList, setScDamageClaimNotSubmitUserList] = useState(null)


  // missing qty MissingQty
  const [scMissingQtyCompleteCount, setScMissingQtyCompleteCount] = useState(0)
  const [scMissingQtyCompleteCountById, setScMissingQtyCompleteCountById] = useState(null)
  const [scMissingQtyCompleteUserList, setScMissingQtyCompleteUserList] = useState(null)

  const [scMissingQtyPendingCount, setScMissingQtyPendingCount] = useState(0)
  const [scMissingQtyPendingCountById, setScMissingQtyPendingCountById] = useState(null)
  const [scMissingQtyPendingUserList, setScMissingQtyPendingUserList] = useState(null)

  const [scMissingQtyClaimNotSubmitCount, setScMissingQtyClaimNotSubmitCount] = useState(0)
  const [scMissingQtyClaimNotSubmitCountById, setScMissingQtyClaimNotSubmitCountById] = useState(null)
  const [scMissingQtyClaimNotSubmitUserList, setScMissingQtyClaimNotSubmitUserList] = useState(null)

  // used-return
  const [scUsedReturnCompleteCount, setScUsedReturnCompleteCount] = useState(0)
  const [scUsedReturnComplete, setScUsedReturnComplete] = useState(null)
  const [scUsedReturnCompleteUserList, setScUsedReturnCompleteUserList] = useState(null)

  const [scUsedReturnPendingCount, setScUsedReturnPendingCount] = useState(0)
  const [scUsedReturnPending, setScUsedReturnPending] = useState(null)
  const [scUsedReturnPendingUserList, setScUsedReturnPendingUserList] = useState(null)

  const [scUsedReturnClaimNotSubmitCount, setScUsedReturnClaimNotSubmitCount] = useState(0)
  const [scUsedReturnClaimNotSubmit, setScUsedReturnClaimNotSubmit] = useState(null)
  const [scUsedReturnClaimNotSubmitUserList, setScUsedReturnClaimNotSubmitUserList] = useState(null)

  const [loading, setLoading] = useState(defaultProvider.loading)
  const [loadingById, setLoadingById] = useState(false)
  const [error, setError] = useState('')

  const userdata = userData()

  const totalClaim = async () => {
    let token = JSON.parse(localStorage.getItem("userData"))
    await axios.post(
      `${process.env.REACT_APP_BASE_URL}/get-dashboard-data`,
      {
        returnNotReceived: true,
        isForBarcodeScanner: false,
        searchBy: "order_id",
        skip: 0,
        limit: 10
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    ).then(async response => {
      setTotalCounts((prev) => ({
        otp_less: 0,
        payment: 0,
        returns: 0,
        loss: 0,
      }));
    })
  }

  const reduceClaimData = (data, filterFn) =>
    data.reduce((acc, item) => {
      if (filterFn(item)) acc[item.gstProfileId] = (acc[item.gstProfileId] || 0) + item.count;
      return acc;
    }, {});

  const completedClaim = async () => {
    let token = JSON.parse(localStorage.getItem("userData"));
    setLoading(true);
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BASE_URL}/smart-claim/count`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const excludeIds = [33, 27, 44, 50, 176, 561, 979];

      // Define claim type configs
      const configs = [
        // customer return
        {
          key: 'CustomerReturn',
          type: 'CUSTOMER_RETURN',
          claimType: 'WRONG',
          completeSetter: setScCustomerReturnComplete,
          pendingSetter: setScCustomerReturnPending,
          notSubmitSetter: setScCustomerReturnClaimNotSubmit,
          completeCountSetter: setScCustomerReturnCompleteCount,
          pendingCountSetter: setScCustomerReturnPendingCount,
          notSubmitCountSetter: setScCustomerReturnClaimNotSubmitCount,
        },
        // rto return
        {
          key: 'RtoReturn',
          type: 'RTO_RETURN',
          claimType: 'WRONG',
          completeSetter: setScRtoReturnComplete,
          pendingSetter: setScRtoReturnPending,
          notSubmitSetter: setScRtoReturnClaimNotSubmit,
          completeCountSetter: setScRtoReturnCompleteCount,
          pendingCountSetter: setScRtoReturnPendingCount,
          notSubmitCountSetter: setScRtoReturnClaimNotSubmitCount,
        },
        // non barcode rto
        {
          key: 'NonBarcodeRto',
          type: 'NON_BARCODED_RTO',
          claimType: 'WRONG',
          completeSetter: setScNonBarcodeRtoCompleteCountById,
          pendingSetter: setScNonBarcodeRtoPendingCountById,
          notSubmitSetter: setScNonBarcodeRtoClaimNotSubmitCountById,
          completeCountSetter: setScNonBarcodeRtoCompleteCount,
          pendingCountSetter: setScNonBarcodeRtoPendingCount,
          notSubmitCountSetter: setScNonBarcodeRtoClaimNotSubmitCount,
        },
        // damage
        {
          key: 'Damage',
          type: null,
          claimType: 'DAMAGED',
          completeSetter: setScDamageCompleteCountById,
          pendingSetter: setScDamagePendingCountById,
          notSubmitSetter: setScDamageClaimNotSubmitCountById,
          completeCountSetter: setScDamageCompleteCount,
          pendingCountSetter: setScDamagePendingCount,
          notSubmitCountSetter: setScDamageClaimNotSubmitCount,
        },
        // missing qty
        {
          key: 'MissingQty',
          type: null,
          claimType: 'MISSING_QTY',
          completeSetter: setScMissingQtyCompleteCountById,
          pendingSetter: setScMissingQtyPendingCountById,
          notSubmitSetter: setScMissingQtyClaimNotSubmitCountById,
          completeCountSetter: setScMissingQtyCompleteCount,
          pendingCountSetter: setScMissingQtyPendingCount,
          notSubmitCountSetter: setScMissingQtyClaimNotSubmitCount,
        },
        // used return
        {
          key: 'UsedReturn',
          type: 'CUSTOMER_RETURN',
          claimType: 'USED',
          completeSetter: setScUsedReturnComplete,
          pendingSetter: setScUsedReturnPending,
          notSubmitSetter: setScUsedReturnClaimNotSubmit,
          completeCountSetter: setScUsedReturnCompleteCount,
          pendingCountSetter: setScUsedReturnPendingCount,
          notSubmitCountSetter: setScUsedReturnClaimNotSubmitCount,
        }
      ];

      // Calculate and set all claim types in a loop
      configs.forEach(cfg => {
        // Complete
        const completeObj = reduceClaimData(data, item =>
          item.statusOfClaim === "COMPLETED" &&
          (!cfg.type || item.returnTypes === cfg.type) &&
          item.typeOfClaim === cfg.claimType &&
          !excludeIds.includes(item.gstProfileId)
        );
        cfg.completeSetter({ ...completeObj });
        cfg.completeCountSetter(Object.values(completeObj).reduce((sum, v) => sum + v, 0));

        // Pending
        const pendingObj = reduceClaimData(data, item =>
          item.statusOfClaim === "PENDING" &&
          (!cfg.type || item.returnTypes === cfg.type) &&
          item.typeOfClaim === cfg.claimType &&
          !excludeIds.includes(item.gstProfileId)
        );
        cfg.pendingSetter({ ...pendingObj });
        cfg.pendingCountSetter(Object.values(pendingObj).reduce((sum, v) => sum + v, 0));

        // Not Submitted
        const notSubmitObj = reduceClaimData(data, item =>
          item.statusOfClaim === "CLAIM_NOT_SUBMITTED" &&
          (!cfg.type || item.returnTypes === cfg.type) &&
          item.typeOfClaim === cfg.claimType &&
          !excludeIds.includes(item.gstProfileId)
        );
        cfg.notSubmitSetter({ ...notSubmitObj });
        cfg.notSubmitCountSetter(Object.values(notSubmitObj).reduce((sum, v) => sum + v, 0));
      });

      // Set totalCounts (example, adjust as needed)
      setTotalCounts(prev => {
        const customer_return = Object.values(reduceClaimData(data, item =>
          item.statusOfClaim === "PENDING" &&
          item.returnTypes === 'CUSTOMER_RETURN' &&
          item.typeOfClaim === 'WRONG' &&
          !excludeIds.includes(item.gstProfileId)
        )).reduce((a, b) => a + b, 0);

        const wrong_rto = Object.values(reduceClaimData(data, item =>
          item.statusOfClaim === "PENDING" &&
          item.returnTypes === 'RTO_RETURN' &&
          item.typeOfClaim === 'WRONG' &&
          !excludeIds.includes(item.gstProfileId)
        )).reduce((a, b) => a + b, 0);

        const non_barcode_rto = Object.values(reduceClaimData(data, item =>
          item.statusOfClaim === "PENDING" &&
          item.returnTypes === 'NON_BARCODED_RTO' &&
          item.typeOfClaim === 'WRONG' &&
          !excludeIds.includes(item.gstProfileId)
        )).reduce((a, b) => a + b, 0);

        const damage = Object.values(reduceClaimData(data, item =>
          item.statusOfClaim === "PENDING" &&
          item.typeOfClaim === 'DAMAGED' &&
          !excludeIds.includes(item.gstProfileId)
        )).reduce((a, b) => a + b, 0);

        const missing_qty = Object.values(reduceClaimData(data, item =>
          item.statusOfClaim === "PENDING" &&
          item.typeOfClaim === 'MISSING_QTY' &&
          !excludeIds.includes(item.gstProfileId)
        )).reduce((a, b) => a + b, 0);

        const used = Object.values(reduceClaimData(data, item =>
          item.statusOfClaim === "PENDING" &&
          item.returnTypes === 'CUSTOMER_RETURN' &&
          item.typeOfClaim === 'USED' &&
          !excludeIds.includes(item.gstProfileId)
        )).reduce((a, b) => a + b, 0);

        const smart_claim = customer_return + wrong_rto + non_barcode_rto + damage + missing_qty + used;

        return {
          customer_return,
          wrong_rto,
          non_barcode_rto,
          damage,
          missing_qty,
          used,
          smart_claim
        };
      });


      setLoading(false);
    } catch (error) {
      if ((error.response && error.response.status === 403) || !token) {
        localStorage.removeItem("userData");
        navigate('/login');
      } else {
        setError('Something Went Wrong');
        setTimeout(() => setError(''), 3000);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("email") && localStorage.getItem("userData")) {
      completedClaim();

      // totalClaim();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const mapUserDataToClaims = (userList, claimObj) => {
    if (!userList || !claimObj) return null;
    const matchingIds = new Set(Object.keys(claimObj).map(Number));
    return userList
      .filter(record => matchingIds.has(record.id))
      .map(record => ({
        platformEmail: record.platformEmail,
        id: record.id,
        email: record.user.email,
        companyName: record.companyName,
        gst: record.gst,
        count: claimObj[record.id] || 0
      }));
  };

  useEffect(() => {
    if (!userdata.user) return;
    setScCustomerReturnCompleteUserList(mapUserDataToClaims(userdata.user, scCustomerReturnComplete));
    setScCustomerReturnPendingUserList(mapUserDataToClaims(userdata.user, scCustomerReturnPending));
    setScCustomerReturnClaimNotSubmitUserList(mapUserDataToClaims(userdata.user, scCustomerReturnClaimNotSubmit));
    setScRtoReturnCompleteUserList(mapUserDataToClaims(userdata.user, scRtoReturnComplete));
    setScRtoReturnPendingUserList(mapUserDataToClaims(userdata.user, scRtoReturnPending));
    setScRtoReturnClaimNotSubmitUserList(mapUserDataToClaims(userdata.user, scRtoReturnClaimNotSubmit));
    setScNonBarcodeRtoCompleteUserList(mapUserDataToClaims(userdata.user, scNonBarcodeRtoCompleteCountById));
    setScNonBarcodeRtoPendingUserList(mapUserDataToClaims(userdata.user, scNonBarcodeRtoPendingCountById));
    setScNonBarcodeRtoClaimNotSubmitUserList(mapUserDataToClaims(userdata.user, scNonBarcodeRtoClaimNotSubmitCountById));
    setScDamageCompleteUserList(mapUserDataToClaims(userdata.user, scDamageCompleteCountById));
    setScDamagePendingUserList(mapUserDataToClaims(userdata.user, scDamagePendingCountById));
    setScDamageClaimNotSubmitUserList(mapUserDataToClaims(userdata.user, scDamageClaimNotSubmitCountById));
    setScMissingQtyCompleteUserList(mapUserDataToClaims(userdata.user, scMissingQtyCompleteCountById));
    setScMissingQtyPendingUserList(mapUserDataToClaims(userdata.user, scMissingQtyPendingCountById));
    setScMissingQtyClaimNotSubmitUserList(mapUserDataToClaims(userdata.user, scMissingQtyClaimNotSubmitCountById));
    setScUsedReturnCompleteUserList(mapUserDataToClaims(userdata.user, scUsedReturnComplete));
    setScUsedReturnPendingUserList(mapUserDataToClaims(userdata.user, scUsedReturnPending));
    setScUsedReturnClaimNotSubmitUserList(mapUserDataToClaims(userdata.user, scUsedReturnClaimNotSubmit));
  }, [
    userdata.user,
    scCustomerReturnComplete,
    scCustomerReturnPending,
    scCustomerReturnClaimNotSubmit,
    scRtoReturnComplete,
    scRtoReturnPending,
    scRtoReturnClaimNotSubmit,
    scNonBarcodeRtoCompleteCountById,
    scNonBarcodeRtoPendingCountById,
    scNonBarcodeRtoClaimNotSubmitCountById,
    scDamageCompleteCountById,
    scDamagePendingCountById,
    scDamageClaimNotSubmitCountById,
    scMissingQtyCompleteCountById,
    scMissingQtyPendingCountById,
    scMissingQtyClaimNotSubmitCountById,
    scUsedReturnComplete,
    scUsedReturnPending,
    scUsedReturnClaimNotSubmit
  ]);

  const getRecordById = (params, errorCallback) => {
    let token = JSON.parse(localStorage.getItem("userData"))
    if (!token) {
      if (errorCallback) errorCallback('Authentication error: No token found.')

      return
    }

    setLoadingById(true)
    let api
    if (params.typeOfClaim === 'WRONG') {
      api = `${process.env.REACT_APP_BASE_URL}/smart-claim?statusOfClaim=${params.statusTab}&returnTypes=${params.type}&typeOfClaim=${params.typeOfClaim}&gstId=${params.gstId}&size=${params.size}&page=${params.page}&direction=${params.direction}&sort=${params.sort}`
      if (params.search) {
        api += `&search=${params.search}`;
      }
      if (params.startDate) {
        api += `&startDate=${params.startDate}&endDate=${params.endDate}`;
      }
    } else {
      api = `${process.env.REACT_APP_BASE_URL}/smart-claim?statusOfClaim=${params.statusTab}&typeOfClaim=${params.typeOfClaim}&gstId=${params.gstId}&size=${params.size}&page=${params.page}&direction=${params.direction}&sort=${params.sort}`
      if (params.search) {
        api += `&search=${params.search}`;
      }
      if (params.startDate) {
        api += `&startDate=${params.startDate}&endDate=${params.endDate}`;
      }
    }
    axios
      .get(api, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(async response => {
        if (errorCallback) errorCallback({ status: 'success' })
        setSelectedUserData(response.data)
      })
      .catch(err => {
        setSelectedUserData(null)
        if (errorCallback) errorCallback({ status: 'Error' })
      }).finally(() => {
        setLoadingById(false)
      })
  }


  const postClaimSubmit = (params, errorCallback) => {
    let token = JSON.parse(localStorage.getItem("userData"))
    if (!token) {
      if (errorCallback) errorCallback('Authentication error: No token found.')

      return
    }
    // setLoadingById(true)

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/smart-claim`, params, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(async response => {
        if (errorCallback) errorCallback({ status: 'success' })
        setSelectedUserData(response.data)
      })
      .catch(err => {
        setSelectedUserData(null)
        if (errorCallback) errorCallback({ status: 'Error' })
      }).finally(() => {
        // setLoadingById(false)
      })
  }

  const values = {
    // customer return
    scCustomerReturnCompleteCount,
    scCustomerReturnCompleteUserList,
    scCustomerReturnPendingCount,
    scCustomerReturnPendingUserList,
    scCustomerReturnClaimNotSubmitCount,
    scCustomerReturnClaimNotSubmitUserList,

    // rto
    scRtoReturnCompleteCount,
    scRtoReturnCompleteUserList,
    scRtoReturnPendingCount,
    scRtoReturnPendingUserList,
    scRtoReturnClaimNotSubmitCount,
    scRtoReturnClaimNotSubmitUserList,

    // non barcode
    scNonBarcodeRtoCompleteCount,
    scNonBarcodeRtoCompleteUserList,
    scNonBarcodeRtoPendingCount,
    scNonBarcodeRtoPendingUserList,
    scNonBarcodeRtoClaimNotSubmitCount,
    scNonBarcodeRtoClaimNotSubmitUserList,

    // Damage
    scDamageCompleteCount,
    scDamageCompleteUserList,
    scDamagePendingCount,
    scDamagePendingUserList,
    scDamageClaimNotSubmitCount,
    scDamageClaimNotSubmitUserList,

    // missing qty
    scMissingQtyCompleteCount,
    scMissingQtyCompleteUserList,
    scMissingQtyPendingCount,
    scMissingQtyPendingUserList,
    scMissingQtyClaimNotSubmitCount,
    scMissingQtyClaimNotSubmitUserList,

    // used return
    scUsedReturnCompleteCount,
    scUsedReturnCompleteUserList,
    scUsedReturnPendingCount,
    scUsedReturnPendingUserList,
    scUsedReturnClaimNotSubmitCount,
    scUsedReturnClaimNotSubmitUserList,

    selectedUserData,
    loading,
    totalCounts,
    setLoading,
    loadingById,
    error,
    setLoadingById,
    getRecordById: getRecordById,
    completedClaim: completedClaim,
    totalClaim: totalClaim,
    postClaimSubmit: postClaimSubmit,
    setSelectedUserData: setSelectedUserData
  }

  return <SmartClaimContext.Provider value={values}>{children}</SmartClaimContext.Provider>
}

export { SmartClaimContext, SmartClaimProvider }
